import { Component, inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { InputField } from '../../../../shared/components/input-field/input-field';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { FORM_ERROR_MESSAGES } from '../../../dashboard/dialogs/add-website-dialog/add-website-dialog.const';
import { WebsiteEnvironment } from '../../../../shared/models/website-create.models';

@Component({
  selector: 'app-add-alias-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    InputField,
    MatCheckboxModule,
  ],
  templateUrl: './add-alias-dialog.component.html',
  styleUrl: './add-alias-dialog.component.scss',
})
export class AddAliasDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<AddAliasDialogComponent>);

  readonly data = inject<DialogData & { websiteId: number }>(MAT_DIALOG_DATA);

  private fb = inject(FormBuilder);

  readonly errors = FORM_ERROR_MESSAGES;

  form = this.fb.nonNullable.group({
    websiteId: [0, [Validators.required]],
    domain: ['', [Validators.required, this.domainValidator]],
    websiteEnvironment: [WebsiteEnvironment.ALIAS],
    excludeActions: [],
    emailService: [], // To be checked
  });

  ngOnInit(): void {
    this.form.controls.websiteId.setValue(this.data.websiteId);
  }

  submit(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.getRawValue());
  }

  close(): void {
    this.dialogRef.close();
  }

  private domainValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const isValid = !!value.match(/\w{3,}\.[a-z]{2,}/);
    return isValid ? null : { invalidDomain: true };
  }
}
